import React, {useCallback, useEffect, useState} from 'react';

import {Link, useNavigate} from "react-router-dom";

import {Helmet} from "react-helmet";

import UrsHeader from "../components/UrsHeader";

const {REACT_APP_SERVER} = process.env;

function UrsReports(props) {


    return (
        <>
            <Helmet>
                <title>Report</title>
            </Helmet>
            <UrsHeader />
            <div className="urs_table" style={{display: 'flex', justifyContent: 'center'}}>
                <div className="container tableParent  file" style={window.innerWidth <= 1024 ? {
                    overflow: 'auto',
                    background: 'white',
                    padding: 35
                } : {background: 'white', padding: 35}}>
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <div>
                            <div>
                                <Link className="custom_span" to="/voip_report" style={{cursor: 'pointer', marginRight: 5}}
                                      >VoIP Report </Link>
                                |
                                <Link className="custom_span" to="/voip_in" style={{cursor: 'pointer', margin: 5}}
                                      >VoIP Mutqer</Link>
                                |

                            </div>

                        </div>
                    </div>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>

                        </thead>
                        <tbody>

                        </tbody>

                    </table>
                </div>
            </div>

        </>
    );
}

export default UrsReports;
